import React from "react";
import ModalCustomAvisos from "../../molecules/ModalCustomAvisos";
import ModalCustomContainer from "../../molecules/ModalCustomContainer";
import styled from 'styled-components';

const Title = styled.p`
color:  ${(props) => (props.titleColorcolor ? props.titleColorcolor  : "#000000" )}; 
font-family: "Amx-Bold";
font-size: ${(props) => (props.titleFontSize ? props.titleFontSize  : "20px" )};
font-weight: bold; 
text-align: center;
margin: ${(props) => (props.titleMargin ? props.titleMargin  : "10% 5% 5% 5%" )};
line-height: 28px;
`;

const Subtitle = styled.p`
    color: #000000;
    font-family: "Amx-Regular";
    font-size: 16px;
    text-align: center;
    margin: 5% 10% 3.2vh 10%;
`;

const Img = styled.img`
    width: 100%;
    text-align: center;
    margin-bottom: 6.2vh;
`;

const ImgContainer = styled.div`
    text-align: center;
`;

const Button  = styled.div`
    float: none;
    color: #fff;
    text-align: center;
    border: none;
    border-color: #ffffff;
    width: 51.111vw;
    height: 8.4667vw;
    background-color: #000;
    border-radius: 50em;
    line-height: normal !important;
    margin: 0 auto 5vh auto;
    font-size: 4.05vw !important;
    font-weight: 'bold';
    font-family: "Amx-Regular" !important;
    padding: 6px;
    white-space: normal;
    word-wrap: break-word;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Link  = styled.p`
    width: 50%;
    margin: ${(props) => (props.margin ? props.margin  : "5% auto 10% auto" )}; 
    text-align: center;
    color: ${(props) => (props.color ? props.color  : "#fff" )};
    font-family: "Amx-Bold";
    text-decoration: underline
    font-size: 14px;
`;

const ToolTipTelcelAvisos = (props) => {
    const {
        isOpen,
        tooltipInformation, 
        handleCloseHelpTooltip,
        handleNextAction,
        handleDontShowAgain,
        background
    } = props;
    const {subject, message, icon, buttons} = tooltipInformation.data
    const data = 'lorem <strong>ipsum</strong>'

    return (
        <ModalCustomContainer isOpen={isOpen}>
        <ModalCustomAvisos isOpen={isOpen} background={background} className="">
            <Title 
                titleColorcolor={props.color}
                titleFontFamily={props.titleFontFamily && props.titleFontFamily}
                titleFontSize={props.titleFontSize && props.titleFontSize}
                titleMArgin={props.titleMargin && props.titleMargin}
                dangerouslySetInnerHTML={{__html: subject}}
            ></Title>
            <Subtitle dangerouslySetInnerHTML={{__html: message}}></Subtitle>
        <ImgContainer>
            <Img
                src={icon}
                alt={""}

            />
        </ImgContainer>
        {
            buttons[0] ? <Button 
                background={"#000000"} 
                color={"#ffffff"}
                margin={"10% auto 5% auto"}
                onClick={handleNextAction}
            >
                {buttons[0]}
            </Button> :<></>
        }
         {
            buttons[1] ? <Link
            color={"black"}
            marginBottom={"1px solid #fff"}
                onClick={handleDontShowAgain}
            >
                {buttons[1]}
            </Link> : <></>
        }
        {
            buttons[2] ? <Button 
                background={"rgba(0, 0, 0, 0.1)"} 
                color={"#fff"}
                border={"1px solid #fff"}
                onClick={handleCloseHelpTooltip}
            >
            {buttons[2]}
            </Button> : <></>
        }
       
        </ModalCustomAvisos>
        </ModalCustomContainer>
        
    );
};

export default ToolTipTelcelAvisos;